import { Injectable } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  ValidatorFn,
  AbstractControl
} from '@angular/forms';
import { PASSWORD_VALIDATOR_PATTERN } from '@core/constants/FomPatterns';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordFormService {
  constructor() {}

  initForm(): UntypedFormGroup {
    return new UntypedFormGroup({
      currentPassword: new UntypedFormControl('', Validators.required),
      newPassword: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(PASSWORD_VALIDATOR_PATTERN)
      ]),
      confirmPassword: new UntypedFormControl('', [
        Validators.required,
        this.confirmPasswordValidator()
      ])
    });
  }

  confirmPasswordValidator(): ValidatorFn {
    return (control: AbstractControl) =>
      !!control.parent?.get('newPassword')?.value &&
      !!control.value &&
      control.parent?.get('newPassword')?.value === control.value
        ? null
        : { confirmPassword: true };
  }
}
